import { Button, Card, Col, Result, Row } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/logo.webp";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="register-wrapper" style={{minHeight : "879px"}}>
      <div className="form-parent">
        <Row justify="center" style={{ width: "100%", marginBottom: 30 }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={logo} style={{ width: 300, maxWidth: "100%" }} alt="Logo" />
            </div>
          </Col>
        </Row>
      </div>
        <Card 
          style={{ 
            maxWidth: 500, 
            width: '100%',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '8px',
            margin: '0 auto'
          }}
        >
        <Result
            status="success"
            title={<span style={{ color: '#52c41a', fontSize: '24px', fontWeight: 'bold' }}>Payment Successful!</span>}
            subTitle={
              <div style={{ marginTop: '20px' }}>
                <p style={{ color: '#fff', fontSize: '16px', marginBottom: '8px' }}>
                  Thank you for your payment! Your transaction was completed successfully.
                </p>
              </div>
            }
          extra={[
            <Button 
              type="primary" 
                key="dashboard" 
                onClick={() => navigate("/")}
              style={{ 
                backgroundColor: '#f6f233',
                borderColor: '#f6f233',
                  color: '#000000',
                  fontWeight: '500',
                  padding: '0 24px',
                  height: '40px',
                  borderRadius: '4px'
              }}
            >
                Go to Login Page
            </Button>,
          ]}
        />
      </Card>
    </div>
  );
};

export default PaymentSuccess;
